<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title-logo">
                {{ $t('send') }}
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
            @click.passive="onClickBack()"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                class="img-backkey"> 
            </div>  
        </div> 
        <!-- 시세창 -->
        <div class="price-box">
            <img 
            src="@/assets/price_bg.png"
            class="img-price-box"> 
            <div class="txt-eth-price">{{this.mSymbol}}  {{ $t('market_price') }} </div>
            <div class="txt-eth-value" v-show="this.$langUtil.getCurrency() == 'krw'">{{this.mCoinPriceKRW}}</div>
            <div class="txt-eth-value" v-show="this.$langUtil.getCurrency() == 'usd'">{{this.mCoinPriceUSD}}</div>
            <div class="txt-eth-unit" v-show="this.$langUtil.getCurrency() == 'krw'">{{ $t('krw_won') }}</div>
            <div class="txt-eth-unit" v-show="this.$langUtil.getCurrency() == 'usd'">{{ $t('usd') }}</div>
        </div> 
        <!-- 디지파이넥스로고 -->
        <div class="css-img-digifinex"
        v-ripple="{ center: true, class: `teal--text`  }">
            <img 
            src="@/assets/digifinex_logo.png"
            class="img-digifinex-logo"> 
        </div>   
        <div class="css-txt-digifinex">{{ $t('support') }}</div>   
        <!-- 이더로고 -->
        <div class="ether-logo-position">
             <img 
            :src="this.mIconUrl"
            class="img-ether-logo"> 
        </div>    
        <!-- 이더량 -->
        <div class="ether-amount">{{$satoshiUtil.satoshiToMCH(this.mBalance)}} {{this.mSymbol}}</div>   
        <!-- 라인 -->
        <div class="bottom-line"></div>
        <!-- 라인 -->
        <div class="bottom-blue01-line"></div>
        <!-- 라인 -->
        <div class="bottom-blue02-line"></div>

        <!-- 라인 -->
        <div class="amount-input-line"></div>
        <!-- 라인 -->
        <div class="address-input-line"></div> 
        <!-- 수량을 입력하세요 -->
        <input class="input-amount" type="text" v-model="mSendAmount" :placeholder=" $t('input_amount') ">
        <!-- Amount ETH -->
        <div class="txt-amount-unit">{{this.mSymbol}}</div>  
        <!-- 삭제아이콘 -->
        <div class="btn-delete-icon"
        v-show="mShowDelIcon"
        v-ripple="{ center: true, class: `teal--text`  }"
        @click.passive="onClickDelete()">
            <img 
            src="@/assets/delete_icon.png"
            class="img-delete-icon"> 
        </div> 
        <!-- 수량을 입력하세요 -->
        <input class="input-address" type="text" v-model="mSendAddress" :placeholder=" $t('input_address') ">
        <!-- 붙여넣기 -->
        <div class="btn-paste-postion"
        v-ripple="{ center: true, class: `teal--text`  }"
        >
            <img 
            src="@/assets/btn_paste.png"
            @click.passive="onClickPaste()"
            class="img-paste-postion"> 
            <div class="txt-paste">{{ $t('paste') }}</div>
        </div>
        <!-- QRCode -->
        <div 
        class="btn-qrcode-postion"
        @click.passive="onClickCQCode()"
        :v-show="mShowQRCodeReader"
        v-ripple="{ center: true, class: `teal--text`  }">
            <img 
            src="@/assets/send_qrcode.png"
            class="img-qrcode-postion"> 
        </div>  
        <!-- qr코드 글자 -->
        <div class="txt-qrcode"
        :v-show="mShowQRCodeReader"
        >{{ $t('qrcode') }}</div>
        <!-- 보내기 -->
        <div class="btn-confirm-postion"
        @click.passive="onClickSend()"
        v-ripple="{ center: true, class: `teal--text`  }"> 
            <div class="txt-center-confirm">{{ $t('confirm') }}</div>
        </div>
        <!-- 로딩바 -->
        <div class="loading-bar-postion" v-show="mShowLoading">
            <v-progress-circular
            indeterminate
            color="red"
            ></v-progress-circular>
        </div>
        <!-- QRCode 읽기 팝업 
        <v-dialog v-model="mDialogQRcode" fullscreen hide-overlay transition="dialog-bottom-transition">
            <QRCodePopUp />
        </v-dialog>
        -->
    </v-app>
</template>
<script>
import axios from 'axios';
import QRCodePopUp from '@/views/QRCodePopUp';

export default {
    created() {
        window['paste_address'] = this.pasteAddress;
        let payload = this.$route.query.payload;
        let decrypto = this.$cryptoUtil.decrptoMessage(payload);
        let json = JSON.parse(JSON.parse(decrypto));
        this.mMno = json.mno;
        this.mCoinType = json.coin_type;
        this.mSymbol = json.symbol;
        this.mSymbol = this.mSymbol.toUpperCase();
        this.mIconUrl = json.icon_url;
        this.mAddress = json.address;
        this.mSendFee = json.send_fee;
        this.mLoginKey = json.login_key;
        this.marketPrice();
        this.$EventBus.$on('qrcode_reader_result', (result) => {
            console.log(result);
            if(result != "") {
                this.mSendAddress = result;
            }
            this.mDialogQRcode = false;
        });
        if(this.$appUtil.getLauncher() == 'android' || this.$appUtil.getLauncher() == 'ios') {
            this.mShowQRCodeReader = true;
        } else {
            this.mShowQRCodeReader = false;
        }
    },
    destroyed() {
        console.log("destroyed");
        this.$EventBus.$off('qrcode_reader_result');
    },
    data: () => ({
        mMno : "",
        mPasswd : "",
        mCoinType : "",
        mSymbol : "",
        mCoinPriceKRW : "",
        mCoinPriceUSD : "",
        mShowLoading : false,
        mBalance : "",
        mAddress : "",
        mSendAmount : "",
        mSendAddress : "",
        mShowDelIcon : false,
        mSendFee : "",
        mDialogQRcode : false,
        mLoginKey : "",
        mShowQRCodeReader : false,
    }),
    watch: {
        mSendAmount: function (val) {
            console.log(val)
            if(val.length == 0) {
                this.mShowDelIcon = false;
            } else {
                this.mShowDelIcon = true;
            }
        },
    },
    components: {
        QRCodePopUp
    },
    methods : {
        onClickBack : function() {
            this.$router.go(-1);
        },
        marketPrice : function() {
            let payload = {};
            payload.cmd = "get-market-price";
            payload.mno = this.mMno;
            payload.coin_type = String(this.mCoinType);
            
            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log(response);
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));
                this.mShowLoading = false;
                if(serverResponse.result == "1") { // 성공
                    this.mCoinPriceKRW = this.$currencyUtil.numberWithCommas(serverResponse.coin_price);
                    this.mCoinPriceUSD = this.$currencyUtil.numberWithCommas(serverResponse.coin_price_usd);
                } else if(serverResponse.result == "2") { // 기존사용자존재
                
                } else if(serverResponse.result == "0") { // 오류
                    
                }
                this.getBalance();
            })
            .catch( ()=>{} );
        },
        getBalance : function() {
            let payload = {};
            payload.cmd = "get-balance";
            payload.mno = this.mMno;
            payload.coin_type = this.mCoinType;
            
            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));
                console.log(response);
                this.mShowLoading = false;
                if(serverResponse.result == "1") { // 성공
                    this.mBalance = serverResponse.balance;
                } else if(serverResponse.result == "2") { // 기존사용자존재
                
                } else if(serverResponse.result == "0") { // 오류
                    
                }
            })
            .catch( ()=>{} );
        },  
        onClickPaste : function() {
            if(this.$appUtil.getLauncher() == 'android' || this.$appUtil.getLauncher() == 'ios') {
                try {
                    window.WalletExJs.onClickPaste();
                } catch(error) {
                }
                try {
                    let payload = {};
                    payload.key = "onClickPaste";
                    window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(payload));
                } catch(error) {
                }
                return;
            }
            navigator.clipboard.readText()
            .then(clipText  => {
                console.log('Pasted content: ', clipText );
                this.mSendAddress = clipText;
            })
            .catch(err => {
                console.error('Failed to read clipboard contents: ', err);
            });
        },
        onClickSend : function() {
            if(this.mSendAmount.length == 0) {
                alert(this.$t('input_amount'))
                return;
            }
            if(this.mSendAddress.length == 0) {
                alert(this.$t('input_address'))
                return;
            }
            
            if(this.mCoinType == 2) { // 이더리움 42자
                if(this.mSendAddress.length != 42) {
                    alert(this.$t('wrong_wallet_address'))
                    return;
                }
                if(this.mSendAddress.startsWith("0x") == false) {
                    alert(this.$t('wrong_wallet_address'))
                    return;
                } 
            }
            if(this.mCoinType == 3) { // 미콘캐시34
                if(this.mSendAddress.length != 34) {
                    alert(this.$t('wrong_wallet_address'))
                    return;
                }
                if(this.mSendAddress.startsWith('M') == false) {
                    alert(this.$t('wrong_wallet_address'))
                    return;
                } 
            }
         
            let payload = {};
            payload.mno = this.mMno;
            payload.send_amount = this.mSendAmount;
            payload.send_address = this.mSendAddress; 
            payload.coin_type = this.mCoinType;
            payload.coin_price_krw = this.mCoinPriceKRW;
            payload.coin_price_usd = this.mCoinPriceUSD;
            payload.balance = this.mBalance;
            payload.symbol =  this.mSymbol;
            payload.send_fee = this.mSendFee;
            payload.login_key = this.mLoginKey;
            payload.icon_url = this.mIconUrl;
            let payloadJson = JSON.stringify(payload);
            let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
            this.$router.push( { path : 'send_result', query: { payload : crypto}});
        },
        onClickDelete : function() {
            this.mSendAmount = "";
        },
        onClickCQCode : function() {
            console.log("onClickCQCode")
            this.mDialogQRcode = true;
            if(this.$appUtil.getLauncher() == 'android' || this.$appUtil.getLauncher() == 'ios') {
                try {
                    window.WalletExJs.onClickQRCode();
                } catch(error) {
                }
                try {
                    let payload = {};
                    payload.key = "onClickQRCode";
                    window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(payload));
                } catch(error) {
                }
            } 
        },
        pasteAddress : function(msg) {
            this.mSendAddress = msg;
        }
  }
}
</script>
<style scoped>
  * {
      margin: 0;
      font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
      font-weight: 300;
      padding: 0;
  }
  html, body {
    height: 100vh;
    width: 100vw;
  }
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
    height: 13.24vw;
    width: 100vw;
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-title-logo {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;
}
.img-title-logo {
    height: 5.925926vw;
    width: 37.407vw;
}
.price-box {
    position: absolute;
    top: 15.37vw; 
    left: 5.6vw;
    height: 8.148vw;
    width: 88.9vw; 
}
.img-price-box {
    height: 8.148vw;
    width: 88.9vw; 
}
.txt-eth-price {
    position: absolute;
    top: 50%; 
    left: 5.5vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-value {
    position: absolute;
    top: 50%; 
    right: 14vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-unit {
    position: absolute;
    top: 50%; 
    right: 6.2vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.ether-logo-position {
    position: absolute;
    top: 28.148vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);     
}
.img-ether-logo {
    width: auto;    
    height: 8.333vw; 
}
.ether-amount {
    position: absolute;
    top: 37.96296vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    font-family: NanumBarunGothicOTF;
    font-size: 5.092593vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;        
}
.btn-receive {
    position: absolute;
    top: 47.7777vw; 
    left: 25.6vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.btn-send {
    position: absolute;
    top: 47.7777vw; 
    left: 43.7vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.btn-convert {
    position: absolute;
    top: 47.7777vw; 
    left: 61.9vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.img-center-icon {
    position: absolute;
    top: 50%; 
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);       
}
.txt-receive-send {
    position: absolute;
    top: 110%; 
    left: 0px;
    width: 100%;
    text-align: center;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #757c7e;   
}
.bottom-line {
    position: absolute;
    top: 47.77778vw; 
    left: 0vw;    
    width: 100vw;
    height: 5px;
    background-color: #f3f6fb;  
}
.bottom-blue01-line {
    position: absolute;
    top: 47.77778vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.bottom-blue02-line {
    position: absolute;
    top: 49vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.txt-history {
    position: absolute;
    top: 74.81481vw; 
    left: 5.8vw;  
    width: 62px;
    height: 20px;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
    pointer-events: none; 
}
.img-period {
    width: 100%;
    height: 7.777vw;
}
.input-period {
    position: absolute;
    top: 81.85185vw; 
    left: 5.6vw; 
    right: 5.6vw;
}
.qrcode-box {
    position: absolute;
    top: 57.407vw; 
    left: 26vw; 
    width: 52.22vw;
    height: 52.22vw;     
    background-color: gray;  
}
.txt-qrcdoe {
    position: absolute;
    top: 111.11vw; 
    left: 0vw;
    width: 100vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center; 
    color:#231815;
    pointer-events: none; 
}
.txt-eth-address {
    position: absolute;
    top: 123.37vw; 
    left: 6.2vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
    pointer-events: none; 
}
.txt-address-bg {
    position: absolute;
    top: 127.963vw; 
    left: 5.6vw; 
    pointer-events: none; 
}
.img-address-bg {
    width: 88.9vw;
    height: 7.407407vw;
}
.btn-copy-address {
    position: absolute;
    top: 143.5185vw; 
    left: 43.148vw;  
}
.img-copy-address {
    width: 13.7037vw;
    height: 13.7037vw;
}
.txt-copy-address {
    position: absolute;
    top: 159.6296vw; 
    left: 50%;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #757c7e; 
    transform: translate(-50%, 0%);  
    pointer-events: none;         
}
.amount-input-line {
    position: absolute;
    top: 62.2222vw; 
    left: 10.2vw;  
    width: 79.62963vw;
    height: 1px;
    background-color: #757c7e;
}
.address-input-line {
    position: absolute;
    top: 76.111vw; 
    left: 10.2vw;  
    width: 79.62963vw;
    height: 1px;
    background-color: #757c7e;
}
.txt-amount-unit {
    position: absolute;
    top: 56.2963vw; 
    right: 10.6vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 4.166vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #626262;
    pointer-events: none; 
}
.btn-delete-icon {
    position: absolute;
    top: 55vw; 
    right: 23vw;  
    width: 5vw;
    height: 5vw;    
}
.btn-paste-postion {
    position: absolute;
    top: 69.25926vw; 
    right: 10.4vw; 
    width: 17.03704vw;
    height: 6.4444vw;  
}
.img-paste-postion {
    width: 17.03704vw;
    height: 6.4444vw;   
}
.txt-paste {
    position: absolute;
    top: 50%;  
    left: 0px;  
    width: 100%;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;   
    transform: translate(0%, -50%);  
    pointer-events: none;         
}
.btn-qrcode-postion {
    position: absolute;
    top: 81.77778vw; 
    left: 43.1vw;  
}
.img-qrcode-postion {
    width: 13.7037vw;
    height: 13.7037vw;  
}
.txt-qrcode {
    position: absolute;
    top: 95.6666vw; 
    left: 45.6vw;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #757c7e;     
    pointer-events: none;    
}
.btn-confirm-postion {
    position: fixed;
    bottom: 0vw; 
    left: 0vw;
    width: 100vw;
    height: 14.35185vw;   
    background-color: #345993;
}
.txt-center-confirm {
    position: absolute;    
    top: 50%;  
    left: 50%;  
    font-family: NanumBarunGothicOTF;
    font-size: 4.1666vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    transform: translate(-50%, -50%);  
    pointer-events: none; 
}
.loading-bar-postion {
    position: absolute;
    top: 50vh;
    left: 50vw; 
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
}
.input-amount {
    position: absolute;
    top: 55vw;
    left: 10vw;
    width: 65vw;
}
.input-address {
    position: absolute;
    top: 69vw;
    left: 10vw;
    width: 60vw;
}
.qrcode-reader-postion {
    position: absolute;
    top: 50vw;
    left: 10vw; 
}
.img-digifinex-logo {
    width: auto;
    height: 5vw; 
}
.css-img-digifinex {
    position: absolute;
    top: 24vw;
    right: 6.5vw; 
}
.css-txt-digifinex {
    position: absolute;
    top: 24.8vw;
    right: 23vw;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #353535;          
}
*:focus {
    outline: none;
}
</style>